import { create } from "zustand";
import type { ParsedStation } from "../lib/nostr/domain";

interface UIState {
  // Login prompt animation
  shouldPulseLogin: boolean;
  pulseLogin: () => void;
  clearLoginPulse: () => void;

  // Root-owned support flow. Keeping this outside navigation sheets prevents
  // nested overlays and lets mobile navigation close before support opens.
  supportOpen: boolean;
  openSupport: () => void;
  closeSupport: () => void;

  // Bottom sheet
  sheetOpen: boolean;
  sheetMode: "nav" | "station";
  sheetStation: ParsedStation | null;
  sheetSnap: "peek" | "expanded";
  sheetFocusComment: boolean;
  openNavSheet: () => void;
  openStationSheet: (station: ParsedStation, focusComment?: boolean) => void;
  closeSheet: () => void;
  setSheetSnap: (snap: "peek" | "expanded") => void;
  clearCommentFocus: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  shouldPulseLogin: false,

  pulseLogin: () => {
    set({ shouldPulseLogin: true });
    setTimeout(() => {
      set({ shouldPulseLogin: false });
    }, 1000);
  },

  clearLoginPulse: () => set({ shouldPulseLogin: false }),

  supportOpen: false,
  openSupport: () =>
    set({
      supportOpen: true,
      sheetOpen: false,
    }),
  closeSupport: () => set({ supportOpen: false }),

  sheetOpen: false,
  sheetMode: "nav",
  sheetStation: null,
  sheetSnap: "peek",
  sheetFocusComment: false,

  openNavSheet: () =>
    set({ sheetOpen: true, sheetMode: "nav", sheetSnap: "peek" }),

  openStationSheet: (station, focusComment = false) =>
    set({
      sheetOpen: true,
      sheetMode: "station",
      sheetStation: station,
      sheetSnap: "expanded",
      sheetFocusComment: focusComment,
    }),

  closeSheet: () => set({ sheetOpen: false }),

  setSheetSnap: (snap) => set({ sheetSnap: snap }),

  clearCommentFocus: () => set({ sheetFocusComment: false }),
}));
